const ListType = Object.freeze({
  news: 'news',
  jobOffers: 'jobOffers',
})

export default ListType
